import Select from "components/shared/select";
import React from "react";

const BaseCarTypeFilter = (props) => {
    const selectProps = {
        placeholder: "Тип грузовика",
        options: props.enums?.carType,
        onChange: props.selectProps.setValue,
        value: props.value,
        ...props.selectProps,
        className: "report__filters--control",
        styles: {
            control: (styles) => ({ ...styles, minHeight: "31px", fontSize: "14px" }),
            indicatorsContainer: (styles) => ({ ...styles, height: "29px" }),
        },
    };
    return (
        <div className="mb-md-0 report__filters--mr">
            <Select {...selectProps} />
        </div>
    );
};

export default BaseCarTypeFilter;
